import { CurrencyFormatted, Typography, Skeleton } from '@ui/components';
import { ResourceType } from '@content-api/api/subscription';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { FC } from 'react';

interface SubscriptionPricingProps {
  billingUnit?: ResourceType;
  costPerUnit?: number;
  isLoading?: boolean;
}

export const SubscriptionPricing: FC<SubscriptionPricingProps> = ({
  billingUnit,
  costPerUnit,
  isLoading,
}) => {
  const { currency } = useCurrentUser();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <>
        <Skeleton className="h-4 w-full mt-20" />
        <Skeleton className="h-4 w-full mt-8" />
      </>
    );
  }

  return (
    <div className="flex items-center justify-between mt-12">
      <Typography variant="labelSmallBook">{t('SUBSCRIPTIONS.PAYMENT').toUpperCase()}</Typography>
      <div className="flex gap-2 items-center">
        <Typography variant="h300" asChild>
          <CurrencyFormatted value={costPerUnit ?? 0} currency={currency} />
        </Typography>
        {billingUnit && (
          <Typography variant="labelSmallBook" className="text-weak">
            / {t(`SUBSCRIPTIONS.BILLING_UNIT.${billingUnit}`)}
          </Typography>
        )}
      </div>
    </div>
  );
};
